<template>
  <div class="backdrop">
    <div class="title-box">
      <img src="../../assets/images/return.png" @click="$router.go(-1)"><span>审批工作台</span>
    </div>
    <div class="tab-head">
      <div :class="{active: my_type === 1}" @click="tab(1)">待处理</div>
      <div :class="{active: my_type === 2}" @click="tab(2)">已发起</div>
      <div :class="{active: my_type === 3}" @click="tab(3)">已处理</div>
      <div :class="{active: my_type === 4}" @click="tab(4)">抄送已读</div>
    </div>
    <div class="common search-box">
      <input type="text" placeholder="单据编号/审批编号/发起人" v-model="search_input">
      <div @click="getList()">搜索</div>
    </div>
    <div class="center-wrapper">
      <div class="center-select layout">
        <div class="flex-1" @click="approvalTypeClick">{{approval_type_name}}<img src="../../assets/images/material-crudejt-down.png"></div>
      </div>
    </div>
    <div class="orderlist-wrapper">
      <div class="order-row mar_bot" v-for="(approval, approval_key) in approval_list" :key="approval_key" @click="toDetail(approval.approval_id, approval.approval_detail_id)">
        <div class="layout mar_bot top">
          <div class="flex-1">{{approval.approval_type_name}}
            <label v-if="approval.step == 0">【抄送】</label>
            <label class="more" v-else>【审批】</label>
          </div>
          <div class="more">{{approval.create_time_info}}</div>
        </div>
        <div class="center">
          <div class="layout mar_bot">
            <div class="flex-1"><label>发起人</label>{{approval.create_member_name}}</div>
          </div>
          <div class="layout mar_bot">
            <div class="flex-1"><label>单据编号</label>{{approval.data_num}}</div>
          </div>
          <div class="layout mar_bot">
            <div class="flex-1"><label>审批单号</label>{{approval.approval_num}}</div>
          </div>
          <div class="layout mar_bot">
            <div class="flex-1"><label>部门</label>{{approval.village_name}} {{approval.department_name}}</div>
          </div>
          <div class="layout mar_bot">
            <div class="flex-1"><label>状态</label>{{approval.status_name}}</div>
          </div>
          <div class="layout mar_bot">
            <div class="flex-1" v-if="my_type == 1"><label>接收时间</label>{{approval.receive_time_info}}</div>
            <div class="flex-1" v-if="my_type == 3"><label>处理时间</label>{{approval.handle_time_info}}</div>
          </div>
        </div>
      </div>
      <div v-if="see_more" @click="getList(2)" class="more">- 点击查看更多 -</div>
    </div>
    <!-- 加载动画 -->
    <div class="loading" v-if="loading">
      <img src="../../assets/images/loading.gif">
    </div>
    <!-- 选择审批类型 -->
    <div class="select-mask" v-if="approvalTypePopup">
      <div class="select-mask-blank" @click="clickBlank"></div>
      <div class="select-mask-inner">
        <div class="select-mask-content">
          <div class="head-mask">选择审批类型<img class="close-mask" @click="approvalTypeClose" src="../../assets/images/close.png"></div>
          <el-tree :data="approvalTypeData" :props="defaultProps" :expand-on-click-node="false" node-key="id" @node-click="selectApprovalType"></el-tree>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  name: 'MyApproval',
  metaInfo: {
    title: '审批'
  },
  data () {
    return {
      my_type: 1,
      loading: false, // 加载动画
      approval_list: [],
      approval_type: 0,
      approval_type_name: '选择审批类型',
      approvalTypePopup: false,
      approvalTypeData: [],
      search_input: '',
      page: 0, // 页码
      see_more: false, // 点击查看更多
      defaultProps: {
        children: 'children',
        label: 'label'
      }
    }
  },
  computed: {
    ...mapState(['villageId', 'memberId'])
  },
  created () {
    this.getApprovalType()
    this.getList()
  },
  methods: {
    // 切换
    tab (e) {
      this.my_type = e
      this.getList()
    },
    getApprovalType () {
      this.axios.post('/wechat/approval/getApprovalTypeTree', {
        member_id: this.memberId,
        village_id: this.villageId
      }).then((res) => {
        if (res.data.status === 1) {
          this.approvalTypeData = [{id: 0, label: '选择审批类型'}].concat(res.data.data)
        }
      })
    },
    // 获取审批列表
    getList (type = 1) {
      this.loading = true
      var approvalList = this.approval_list
      if (type === 2) {
        // 查看更多
      } else {
        // 搜索条件有变化，需重新获取列表 和 统计数据
        this.approval_list = []
        this.page = 0
        approvalList = []
      }
      // 列表分页数据
      this.axios.post('/wechat/approval/myApproval', {
        member_id: this.memberId,
        village_id: this.villageId,
        my_type: this.my_type,
        approval_type: this.approval_type,
        keywords: this.search_input,
        page: this.page + 1
      }).then((res) => {
        if (res.data.status === 1) {
          this.approval_list = approvalList.concat(res.data.data.approval_list)
          this.page = res.data.data.page
          if (this.approval_list.length >= res.data.data.total) {
            this.see_more = false
          } else {
            this.see_more = true
          }
          this.loading = false
        } else {
          this.loading = false
          this.$toast({
            message: res.data.info,
            duration: 5000
          })
        }
      }).catch(() => {
        this.loading = false
        this.$toast({
          message: '网络错误',
          duration: 5000
        })
      })
    },
    // 详情
    toDetail: function (approvalId, approvalDetailId) {
      var query = {}
      query.approval_id = approvalId
      if (this.my_type === 1) {
        query.approval_detail_id = approvalDetailId
      }
      this.$router.push({name: 'ApprovalInfo', query: query})
    },
    // 点击审批类型
    approvalTypeClick () {
      this.approvalTypePopup = true
    },
    // 关闭审批类型
    approvalTypeClose () {
      this.approvalTypePopup = false
    },
    selectApprovalType (data) {
      this.approval_type = data.id
      this.approval_type_name = data.label
      this.clickBlank()
      this.getList()
    },
    // 点击空白地方关闭
    clickBlank () {
      this.approvalTypePopup = false
    }
  }
}
</script>
<style scoped>
.common {
  padding: 15px 10px;
}
.tab-head {
  display: flex;
  background-color: #ffffff;
}
.tab-head div {
  flex: 1;
  text-align: center;
  padding: 12px 0;
  color: #2f2f2f;
}
.tab-head div img {
  width: 18px;
  height: 18px;
  vertical-align: top;
  padding: 1px 6px 0 0;
}
.tab-head .active {
  color: #d93d55;
  position: relative;
}
.tab-head .active::after {
  content: '';
  position: absolute;
  left: 50%;
  margin-left: -27%;
  bottom: 0;
  width: 55%;
  height: 2px;
  background-color: #d93d55;
}
.center-wrapper {
  background-color: #ffffff;
  padding: 10px;
  margin-bottom: 8px;
}
.center-wrapper .center-select {
  padding-bottom: 10px;
  font-size: 15px;
}
.center-wrapper .center-select img {
  width: 10px;
  height: 10px;
  padding-left: 5px;
}
.center-wrapper .center-select {
  position: relative;
}
.center-wrapper .center-select .select-empty {
  width: 50px;
  text-align: right;
}
.center-wrapper .center-select .select-empty img {
  width: 18px;
  height: 18px;
}
.orderlist-wrapper {
  color: #313131;
  font-size: 13px;
}
.orderlist-wrapper .order-row {
  background-color: #ffffff;
}
.layout {
  display: flex;
}
.layout .flex-1 {
  flex: 1;
}
.orderlist-wrapper .layout .more {
  padding: 0;
}
.orderlist-wrapper .layout .more img {
  width: 20px;
  height: 20px;
}
.orderlist-wrapper .order-row .top {
  border-bottom: 1px solid #f4f4f4;
  padding: 10px;
  font-size: 15px;
}
.orderlist-wrapper .order-row .top .flex-1 {
  font-weight: bold;
}
.orderlist-wrapper .order-row .center {
  border-bottom: 1px solid #f4f4f4;
  padding: 0 10px;
}
.orderlist-wrapper .order-row .center label {
  color: #999;
  display: inline-block;
  width: 64px;
}
.orderlist-wrapper .order-row .bottom {
  padding: 10px;
}
.orderlist-wrapper .order-row .bottom .flex-1 {
  text-align: center;
}
.orderlist-wrapper .order-row .bottom label {
  color: #999;
}
.orderlist-wrapper .order-row .bottom label img {
  width: 9px;
  height: 9px;
  padding-left: 3px;
}
.orderlist-wrapper .order-row .bottom .num {
  font-size: 16px;
  margin-top: 10px;
  font-weight: 600;
}
.mar_bot {
  margin-bottom: 8px;
}
.orderlist-wrapper .more {
  font-size: 14px;
  text-align: center;
  background-color: #ffffff;
  padding: 10px 0;
}
.select-mask {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.2);
  z-index: 1;
}
.select-mask .select-mask-blank {
  width: 100%;
  height: 100%;
}
.select-mask .select-mask-inner {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: #ffffff;
  font-size: 15px;
  height: 300px;
  overflow-y: auto;
}
.select-mask .select-mask-inner .select-mask-content {
  padding: 0 15px;
}
.select-mask .select-mask-inner .head-mask {
  text-align: center;
  height: 40px;
  line-height: 40px;
  border-bottom: 1px solid #f6f6f6;
  position: relative;
}
.select-mask .select-mask-inner .head-mask .close-mask {
  width: 18px;
  height: 18px;
  position: absolute;
  top: 12px;
  right: 10px;
}
.select-mask .select-mask-inner .select-mask-content .level {
  border-bottom: 1px solid #f6f6f6;
  height: 30px;
  line-height: 30px;
  font-size: 14px;
  position: relative;
}
.select-mask .select-mask-inner .select-mask-content label {
  display: block;
  border-bottom: 1px solid #f6f6f6;
  padding: 5px 15px;
}
>>>
.mint-switch-core {
  width: 42px;
  height: 22px;
}
>>>
.mint-switch-core::before {
  width: 40px;
  height: 20px;
}
>>>
.mint-switch-core::after {
  width: 20px;
  height: 20px;
}
>>>
.el-tree-node__expand-icon {
  font-size: 18px;
}
</style>



// WEBPACK FOOTER //
// src/components/Approval/MyApproval.vue